import { tv } from 'tailwind-variants';

export const styleFaq = tv({
  slots: {
    buttonSmFit: 'w-full sm:w-fit h-fit ',
    buttonLgFit: 'w-full lg:w-fit',
    titleIcon: 'text-gray-500 self-center items-center w-6 h-6',
    titleTypography: 'font-semibold ml-3',
  },
});
